import {login, getInfo, logOut} from "../../api/login";
import {getToken, setToken, removeToken} from '@/utils/auth';
import {packageList} from "../../api/package";

const user = {
  state: {
    token: getToken(),
    username: "",
    head: "",
    buyPackageShow:false,
    packageList:[],
    packageBuy:false,   //是否购买套餐
  },
  mutations: {
    SET_PACKAGE_BUY:(state,packageBuy)=>{
      state.packageBuy=packageBuy
    },
    SET_PACKAGE_LIST:(state,packageList)=>{
      state.packageList=packageList
    },
    SET_BUY_PACKAGE_SHOW:(state,buyPackageShow)=>{
      state.buyPackageShow = buyPackageShow
    },
    SET_HEAD: (state, head) => {
      state.head = head
    },
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_USERNAME: (state, username) => {
      state.username = username
    }
  },
  actions: {
    GetPackAge({commit}, params){
      return new Promise((resolve,reject)=>{
        packageList(params).then(res=>{
          commit("SET_PACKAGE_LIST",res.data);
          commit("SET_BUY_PACKAGE_SHOW",true);
          resolve(res)
        }).catch(err=>{
          reject(err)
        })
      })
    },
    Login({commit}, params) {
      return new Promise((resolve, reject) => {
        login(params).then(res => {
          setToken(res.data.token);
          commit('SET_TOKEN', res.data.token);
          commit('SET_USERNAME', res.data.nickname);
          commit('SET_HEAD', res.data.img);
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    },
    GetInfo({commit}, params) {
      return new Promise((resolve, reject) => {
        getInfo(params).then(res => {
          commit('SET_TOKEN', res.data.token);
          commit('SET_USERNAME', res.data.nickname);
          commit('SET_HEAD', res.data.img);
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    },
    // 登出
    LogOut({commit, state}) {
      return new Promise((resolve, reject) => {
        logOut().then((res) => {
          commit('SET_TOKEN', '');
          removeToken();
          sessionStorage.removeItem('breadcrumb');
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    },
    // 前端 登出
    FedLogOut({commit}) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '');
        removeToken();
        sessionStorage.removeItem('breadcrumb');
        resolve()
      })
    }
  }
};

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js